<template>
  <div class="ag-page_alertcs position-relative">
    <ag-card :module="module" @search="search" @main="mainLink"></ag-card>
  </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import AlertConsole from "@/helpers/pages/AlertConsole";
import { AlertStatus } from "@/helpers/enums/AlertStatus";
import { AlertTypes } from "@/helpers/enums/AlertTypes";
import api from "@/store/axiosAgsc";
import moment from "moment";
import { orderBy } from "lodash";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRouter, useRoute } from "vue-router";
import dateOptions from "@/helpers/DateOptions";
import router from "./../../../router";

export default defineComponent({
  name: "AlertConsole",
  data() {
    return {
      tempData: {
        total: 0,
        rows: [],
      },
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const module = ref(AlertConsole);
    const filterComponent = defineAsyncComponent(() =>
      import("@/views/pages/AlertConsole/Filter.vue")
    );
    const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    let filter = ref({
      page: 1,
      limit: 10,
      startDate: moment().utc().startOf("day").subtract(7, "days"),
      endDate: moment().utc(),
      alarmType: null,
      severity: null,
      status: null,
      source: "",
      description: "",
      sortColumn: "",
      sortDir: "",
      ruleName: "",
      searchStr: "",
      groupGuids: [],
    });

    const getList = (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      setTimeout(() => {
        if (route.query.type) {
          filters.alarmType = Number(AlertTypes[route.query.type]);
        }

        if (
          router.currentRoute.value.fullPath &&
          router.currentRoute.value.fullPath.indexOf("/all") === -1 &&
          !route.query.searchResults
        ) {
          if (router.currentRoute.value.fullPath.indexOf("/unresolved") > -1) {
            filters.status = 0;
          } else if (
            router.currentRoute.value.fullPath.indexOf("/inreview") > -1
          ) {
            filters.status = 1;
          } else if (
            router.currentRoute.value.fullPath.indexOf("/resolved") > -1
          ) {
            filters.status = 2;
          }
        } else if (router.currentRoute.value.fullPath.indexOf("/all") > -1) {
          filters.status = null;
        }

        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_ALERTS, body);
      }, 100);
    };

    const searchWithFilters = (param) => {
      if (module.value.filter.filters[0].vmodel) {
        filter.value.groupGuids = [module.value.filter.filters[0].vmodel];
      } else {
        filter.value.groupGuids = [];
      }

      let query = Object.assign({}, route.query);
      if (module.value.filter.filters[1].vmodel)
        query.type =
          AlertTypes[
            module.value.filter.filters[1].vmodel == "-1"
              ? "0"
              : module.value.filter.filters[1].vmodel
          ];
      else delete query.type;
      router.replace({ query });

      if (route.query.type) {
        filter.value.alarmType = Number(AlertTypes[route.query.type]);
      } else {
        if (
          module.value.filter.filters[1].vmodel &&
          module.value.filter.filters[1].vmodel == "-1"
        ) {
          filter.value.alarmType = 0;
        } else
          filter.value.alarmType =
            module.value.filter.filters[1].vmodel || null;
      }

      filter.value.page = module.value.component.options.page || 0;
      filter.value.limit = module.value.component.options.pageSize || 5;
      // filter.value.alarmType = module.value.filter.filters[0].vmodel || "0";
      filter.value.severity = null;
      filter.value.status =
        Number(module.value.filter.filters[2].vmodel) == 99
          ? null
          : Number(module.value.filter.filters[2].vmodel) || null;
      filter.value.source = "";
      filter.value.sortColumn = "";
      filter.value.sortDir = "";
      filter.value.ruleName = module.value.filter.filters[3].vmodel || "";
      filter.value.searchStr = module.value.filter.filters[4].vmodel || "";

      const range = module.value.filter.filters.find((f) => f.param == "range");

      if (param) {
        filter.value.startDate = moment()
          .utc()
          .startOf("day")
          .subtract(7, "days");
        filter.value.endDate = moment().utc();
      } else {
        if (range && range.vmodel && range.vmodel.start) {
          filter.value.startDate = range.vmodel.start;
          filter.value.endDate = range.vmodel.end;
        } else {
          const findDate = module.value.filter.filters.find(
            (f) => f.param == "range"
          );
          filter.value.endDate = moment().utc();
          if (findDate && findDate.vmodel) {
            filter.value.startDate = findDate.vmodel;
          } else {
            filter.value.startDate = moment()
              .utc()
              .startOf("day")
              .subtract(7, "days");
          }
        }
      }

      const filters = filter.value;
      const options = module.value.component.options;
      options.page = 1;
      module.value.readyToUseFilters = filters;
      if (!param) {
        router.push({ query: { searchResults: "true" } });
      }
      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item) => {
        if (item.param == "range") {
          item.vmodel = dateOptions[2].value;
          item.selectedLabel = dateOptions[2].label;
        } else {
          item.vmodel = null;
        }
      });
      searchWithFilters(true);
      let query = Object.assign({}, router.currentRoute.value.query);
      delete query.searchResults;
      router.replace({ query });
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
      filterComponent,
    };
  },
  mounted() {
    this.setFilterStatus();
    localStorage.removeItem("alertDate");
    const filters = this.filter;
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  components: { AgCard },
  methods: {
    mainLink() {
      if (this.tempData.total > 0) {
        this.module.component.options.rows = this.tempData.rows;
        this.module.component.options.total = this.tempData.total;
      } else {
        const filters = this.filter;
        this.module.readyToUseFilters = filters;
        const options = this.module.component.options;
        if (localStorage.getItem("alertDate")) {
          filters.endDate = moment(
            JSON.parse(localStorage.getItem("alertDate")).value
          );
        }
        this.getList(filters, options);
      }
    },
    search() {
      this.tempData.rows = this.module.component.options.rows;
      this.tempData.total = this.module.component.options.total;
      this.module.component.options.rows = [];
      this.module.component.options.total = 0;
    },
  },
  watch: {
    $route(to) {
      if (to.meta.title) {
        this.filter.status = parseInt(AlertStatus[to.meta.title]);
      }
      if (to.query.type) {
        this.filter.alarmType = AlertTypes[to.query.type];
      } else {
        this.filter.alarmType = null;
      }
      if (
        to.path.split("/")[1] === "alert-console" &&
        !to.query.searchResults
      ) {
        const filters = this.filter;
        this.module.readyToUseFilters = filters;
        const options = this.module.component.options;
        options.page = 1;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.fullPath.indexOf("alert-console") === -1) {
      localStorage.removeItem("alertDate");
    }
    next();
  },
});
</script>

<style>
.ag-card_buttons {
  align-items: center;
}
.ag-card_buttons .ag-button {
  height: 37px;
  background: #164b6c;
}
</style>
